import * as getTypes from '../get-types'
import * as actionTypes from '../action-types'
import * as mutationTypes from '../mutation-types'

const state = {
  participatedSurveys: {}
}

const getters = {
  [getTypes.HAS_PARTICIPATED_IN_SURVEY]: state => id => {
    return state.participatedSurveys[id] === true
  }
}

const actions = {
  [actionTypes.ADD_PARTICIPATED_SURVEY] ({ getters, commit }, id) {
    if (getters[getTypes.HAS_PARTICIPATED_IN_SURVEY](id)) {
      return
    }
    commit(mutationTypes.ADD_PARTICIPATED_SURVEY, id)
  }
}

const mutations = {
  [mutationTypes.ADD_PARTICIPATED_SURVEY] (state, id) {
    state.participatedSurveys[id] = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
